import produce from 'immer';
import {
	FETCH_ARTICLES_FAILED,
	FETCH_ARTICLES_FULFILLED,
	FETCH_ARTICLES_PENDING,
} from '../constants/actions/articleActions';
import IArticleListItem from '../interfaces/articles/articleListItem';

type IArticleModel = {
	Id: number;
	PageSize: number;
	TotalItems: number;
	TotalPages: number;
	Items: IArticleListItem[];
};

type IArticleMapper = {
	[key: number]: IArticleModel;
};

type ReducerState = {
	loading: boolean;
	error: boolean;
	articlesMapper: IArticleMapper;
};

const initialState: ReducerState = {
	loading: false,
	error: false,
	articlesMapper: {},
};

const articleReducer = produce((draft: ReducerState, action: any) => {
	switch (action.type) {
		case FETCH_ARTICLES_PENDING: {
			draft.loading = true;
			break;
		}
		case FETCH_ARTICLES_FULFILLED: {
			const { id, articles } = action.payload;
			draft.loading = false;

			if (draft.articlesMapper[id] === undefined) {
				draft.articlesMapper[id] = {
					Id: id,
					PageSize: articles.PageSize,
					TotalItems: articles.TotalItems,
					TotalPages: articles.TotalPages,
					Items: articles.Items,
				};
			}

			break;
		}
		case FETCH_ARTICLES_FAILED: {
			draft.loading = false;
			draft.error = true;
			break;
		}
		default: {
			break;
		}
	}
}, initialState);

export default articleReducer;
